import { CSSProperties, memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { DefinitionService } from "../../services/DefinitionService";
import { mdlNotConfirmListRequest } from "../../models/service-models/notConfirm/NotConfirmListRequest";

export type NotConfirmSelectProps = {
    onChange?: Function;
    defaultValue?: string;
    excludedValue?: string;
    mode?: 'multiple' | 'tags' | undefined;
    style?: CSSProperties;
    selectedHotel?: string;
    onLoad?: Function;

    onClear?: Function;
}


export const NotConfirmSelect = memo(function NotConfirmSelect(props: NotConfirmSelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getNotConfirms"],
        () => {
            var request: mdlNotConfirmListRequest = { pageSize: 0 };
            return DefinitionService.NotConfirmSystemMessagesList(request);
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    useEffect(() => {
        if (data?.body?.data && props.onLoad) {
            props.onLoad(data?.body?.data);
        }
    }, [data]);

    const handleOnClear = () => {
        props.onClear && props.onClear();
    }

    return (
        <>
            <Select
                style={props.style && props.style}
                mode={props.mode && props.mode}
                loading={isLoading}
                size="large"
                defaultValue={props.defaultValue}
                onSelect={(value: string) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("definitions.notConfirm.chooseNotConfirmReasonTemplate")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                allowClear={props.onClear ? true : false}
                onClear={handleOnClear}
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.notConfirmMessageTemplateId
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
})